import React, { useEffect, useState } from 'react';
import useDeviceType from '../../Utiles/FindDevice';
import axios from 'axios';
import { baseURL } from "../../services/axiosConfig"
import { CircularLoader } from './MyTransaction';
import moment from 'moment';
import { refreshTokenV2 } from '../../services/api';
import { useDispatch } from 'react-redux';

const MyWinnings = ({ setTotalWinnings }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const deviceType = useDeviceType();
  const [loading, setLoading] = useState(false);
  const [winnings, setWinnings] = useState([]);
  const token = localStorage.getItem('access_token');
  const dispatch = useDispatch()

  const totalPages = Math.ceil(winnings.length / 10);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${baseURL}/pot/winnings?page=${currentPage}&limit=10`, {
          headers: {
            'Authorization': `Bearer ${JSON.parse(token)}`
          }
        })
        setTotalWinnings(data?.summary || {});
        setWinnings(data?.results || []);
      }
      catch (error) {
        if (error?.response?.status === 401) {
          refreshTokenV2(dispatch);
        }
        console.error('Error fetching winnings data:', error);
      }
      setLoading(false);
    })()
  }, [currentPage]);


  function Pagination({ currentPage, totalPages, onPageChange, isMobile = false }) {
    return (
      <div className={`flex items-center gap-1 ${isMobile ? 'justify-end mt-2' : 'justify-end mt-2'}`}>
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`w-8 h-8 flex items-center justify-center ${isMobile ? 'text-xs' : 'text-sm'} text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-gray-100 rounded border border-gray-200 bg-white`}
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.5 9L4.5 6L7.5 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
          <button
            key={page}
            onClick={() => onPageChange(page)}
            className={`w-8 h-8 flex items-center justify-center ${isMobile ? 'text-xs' : 'text-sm'} font-medium rounded border transition-colors ${page === currentPage
                ? 'bg-blue-500 text-white border-blue-500 shadow-sm'
                : 'text-gray-600 hover:bg-gray-50 border-gray-200 bg-white'
              }`}
          >
            {page}
          </button>
        ))}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
          className={`w-8 h-8 flex items-center justify-center ${isMobile ? 'text-xs' : 'text-sm'} text-gray-600 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-gray-100 rounded border border-gray-200 bg-white`}
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.5 3L7.5 6L4.5 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    );
  }

  if (deviceType === 'mobile') {
    return (
      <div className="p-3 min-h-screen bg-gray-50">
        <div className="">
          <div className="overflow-x-auto bg-white">
            <table className="w-full min-w-[800px]">
              <thead>
                <tr className="bg-gradient-to-r from-[#007fff] to-[#00c05b] text-white">
                  <th className="px-3 py-3 text-left text-xs font-semibold rounded-tl-lg whitespace-nowrap font-archivo">League Name</th>
                  <th className="px-12 py-3 text-left text-xs font-semibold whitespace-nowrap font-archivo">Date</th>
                  <th className="px-3 py-3 text-center text-xs font-semibold whitespace-nowrap font-archivo">Round ID</th>
                  <th className="px-3 py-3 text-center text-xs font-semibold whitespace-nowrap font-archivo rounded-tr-lg">Amount Won</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {loading ? <CircularLoader /> : winnings?.length > 0 ? winnings?.map((item, index) => (
                  <tr key={index} className={index % 2 !== 0 ? 'bg-[#f6faff]' : 'bg-white'}>
                    <td className="p-4 border-b border-slate-100 text-gray-700 text-sm last:border-b-0 text-left text-[#00000099] font-archivo">
                      {item?.season_name}
                    </td>
                    <td className="p-4 border-b border-slate-100 text-gray-700 text-sm last:border-b-0 text-left text-[#00000099] font-archivo">
                      {moment(item?.created_at).format('D MMM hh:mm a')}
                    </td>
                    <td className="p-4 border-b border-slate-100 text-gray-700 text-sm last:border-b-0 text-center text-[#00000099] font-archivo">
                      {item?.round_id}
                    </td>
                    <td className="p-4 border-b border-slate-100 text-gray-700 text-sm last:border-b-0 mx-auto flex justify-center items-center">
                      <div className="flex items-center gap-2">
                        <span className="text-green-500 text-base font-bold">↑</span>
                        <span className="text-green-500 font-semibold font-archivo flex items-center gap-0.5"><span className='text-[16px]'>$</span>{item?.amount}</span>
                        <span className="text-green-500 font-medium font-archivo">/ {item?.no_of_tokens_won} Tokens</span>
                      </div>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan="4" className="p-4 text-center text-gray-500">
                      No winnings found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {winnings?.length > 0 && !loading && (
            <div className="p-3 border-t border-gray-200 bg-white">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className=" mx-auto p-5 font-sans bg-gray-50 rounded-xl">
      <div className="bg-white rounded-xl overflow-hidden shadow-sm mb-6 -mx-4 md:mx-0 border-t border-b border-gray-200 md:border md:border-gray-200">
        <div className="overflow-x-auto px-4 md:px-0 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
          <table className="w-full ">
            <thead className=''>
              <tr className="bg-gradient-to-r from-[#007fff] to-[#00c05b] text-white">
                <th className="px-3 py-3 text-left text-md font-semibold rounded-tl-lg whitespace-nowrap font-archivo">League Name</th>
                <th className="px-8 py-3 text-left text-md font-semibold whitespace-nowrap font-archivo">Date</th>
                <th className="px-3 py-3 text-center text-md font-semibold whitespace-nowrap font-archivo">Round ID</th>
                <th className="px-3 py-3 text-center text-md font-semibold whitespace-nowrap font-archivo">Amount Won</th>
              </tr>
            </thead>
            <tbody>
              {loading ? <CircularLoader /> : winnings?.length > 0 ? winnings?.map((item, index) => (
                <tr key={index} className={index % 2 !== 0 ? 'bg-[#f6faff]' : 'bg-white'}>
                  <td className="p-4 border-b border-slate-100 text-gray-700 text-sm last:border-b-0 text-left text-[#00000099] font-archivo">
                    {item?.season_name}
                  </td>
                  <td className="p-1 border-b border-slate-100 text-gray-700 text-sm last:border-b-0 text-left text-[#00000099] font-archivo">
                    {moment(item?.created_at).format('D MMM hh:mm a')}
                  </td>
                  <td className="p-4 border-b border-slate-100 text-gray-700 text-sm last:border-b-0 text-center text-[#00000099] font-archivo">
                    {item?.round_id}
                  </td>
                  <td className="p-4 border-b border-slate-100 text-gray-700 text-sm last:border-b-0 mx-auto flex justify-center items-center">
                    <div className="flex items-center gap-2">
                      <span className="text-green-500 text-base font-bold">↑</span>
                      <span className="text-green-500 font-semibold font-archivo flex items-center gap-0.5"><span className='text-[16px]'>$</span>{item?.amount}</span>
                      <span className="text-green-500 font-medium font-archivo">/ {item?.no_of_tokens_won} Tokens</span>
                    </div>
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="4" className="p-4 text-center text-gray-500">
                    No winnings found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {
        winnings?.length > 0 && !loading &&
        <div className="flex justify-end gap-2 items-center">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            isMobile={true}
          />
        </div>
      }
    </div>
  );
};

export default MyWinnings;
